import { TreeNode } from "primeng/api";

// TODO: need fix json formatter on backend (lowerCase rule)
export interface FileModel {
  ContentType?: string;
  CreatedOn?: Date;
  FileType?: FileModel.FileTypeEnum;
  Height?: number;
  HtmlContent?: string;
  Id?: string;
  IsFolder?: boolean;
  Link?: string;
  Name?: string;
  ParentFolderId?: string;
  Size?: number;
  Width?: number;
}

export namespace FileModel {
  export type FileTypeEnum = 'ALL' | 'IMAGES' | 'DOCUMENTS' | 'CONTACT' | 'USER' | 'LAYOUTS';
  export const FileTypeEnum = {
    ALL: 'ALL' as FileTypeEnum,
    IMAGES: 'IMAGES' as FileTypeEnum,
    DOCUMENTS: 'DOCUMENTS' as FileTypeEnum,
    CONTACT: 'CONTACT' as FileTypeEnum,
    USER: 'USER' as FileTypeEnum,
    LAYOUTS: 'LAYOUTS' as FileTypeEnum
  };
}

export interface DragAndDropEvent {
  originalEvent: DragEvent;
  isFolderTreeDrop?: boolean;
  draggedItem: FileModel | FileModel[] | TreeNode;
  droppedItem: FileModel;
}